export default {"src":"/_next/static/media/hero-bg.a46a2c42.svg","height":750,"width":1366,"blurWidth":0,"blurHeight":0};